import { render } from "./AppUploadZone.vue?vue&type=template&id=057cb2ce&scoped=true"
import script from "./AppUploadZone.vue?vue&type=script&lang=js"
export * from "./AppUploadZone.vue?vue&type=script&lang=js"

import "./AppUploadZone.vue?vue&type=style&index=0&id=057cb2ce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057cb2ce"]])

export default __exports__